<template>
  <div>
    <vs-loading :loading="loading"></vs-loading>

    <vs-card>
      <div slot="header">
        <vs-title>Dosya Yönetim Ekranı ({{this.etkinlikAdi}})</vs-title>
        
      
      </div>
     
      <div v-if="! saved">
      <vs-button :style="'margin-left:90%'" color="#1f74ff" :to="{name: 'FolderManagement'}" >İleri</vs-button>
      <br/>
          <br/>
            <br/>
       <vs-input  id="deneme" disabled label="Dosyaları Görüntülenen Etkinlik:" class="inputx" placeholder="Etkinlik Seçiniz" v-model="this.etkinlikAdi"/>
        <br/>
          <br/>
            <div class="ort">
            <div class="ort2">
              


          
            <div class="etbil">
               ETKİNLİK DOSYALARI
                 </div>
               <ul id="example-1">
              <li v-for="item in filenamesUpdatedEtkinlikSonrasi" :key="item">
                
              <div class="filenames" @click=" handleDown(item)">
                  <a href="#" style="color:red">{{ item }}</a> 
                </div>
               
              </li>
            </ul>
              </div>
              </div>
            
            <br/>
            <br/>
            <br/>
            <br/>


      
      </div>

     

    </vs-card>

  </div>
</template>

<script>
  import Reqq from "@/libs/reqqs/Reqq";
  
  export default {
    name: "FolderPage",
    title: "Add A Reqq",
    data() {
      return {
        obj: new Reqq(),
        loading: false,
        etkinlikAdi:'',
        filenames:[],
        filenamesUpdatedEtkinlikBilgisi:[],
        filenamesUpdatedDilekSikayet:[],
        filenamesUpdatedEtkinlikSonrasi:[],
        combobox:[
        {text: 'Öneri', value: 'Öneri'},
        {text: 'Talep', value: 'Talep'},
         {text: 'Şikayet', value: 'Şikayet'}
        
       
      ],
      };
    },
    computed: {
      saved() {
        return this.obj.saved
      },
      submitted() {
        return this.obj.form.submitted
      },
      contaminated() {
        return this.obj.form.errorDetected
      },
      errors() {
        return this.obj.form.errors
      }
    },
    watch: {
      contaminated(val) {
        this.loading = false
      },
      submitted(val) {
        if(val)
          this.loading = false
      },
      saved(val) {
        if(val) {
          // handle added
        }
      },
    },
    methods: {
        
         handleDown(item) {
          
         axios({
            url: 'https://eys.hacibayram.edu.tr:8081/api/download/'+'?name='+item, 
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
         
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', item); //or any other extension
            document.body.appendChild(link);
            link.click();
             console.log(response.data.dosya) //dosya adını vs almam lazım
        });
        },  
      save() {
        this.loading = true
         this.obj.columns.eventName=this.etkinlikAdi
        this.obj.create()
      },
      
      addNew() {
        this.obj.reset();
        this.obj.saved = false
      }
    },
    mounted() {
      this.etkinlikAdi= this.$route.params.id
       this.filenames= this.$route.params.parametre
      

      for (let i = 0; i < this.filenames.length; i++) {
        let evname=this.filenames[i].folder.substring(0,this.filenames[i].folder.indexOf('&&&&&'))
         let folname= this.filenames[i].folder.substring(this.filenames[i].folder.indexOf('&+&+&')+5)
         let classname= this.filenames[i].folder.substring(this.filenames[i].folder.indexOf('&&&&&')+5,this.filenames[i].folder.indexOf('&+&+&'))
         console.log(evname)
         console.log("ff"+folname)
        
        if(evname == this.etkinlikAdi){
          if(classname == 'etkinlik_bilgisi'){
            this.filenamesUpdatedEtkinlikSonrasi.push(folname);
            }
            else if(classname == 'dilek_sikayet'){
            this.filenamesUpdatedEtkinlikSonrasi.push(folname);
            }
            else if(classname == 'etkinlik_sonlandir'){
            this.filenamesUpdatedEtkinlikSonrasi.push(folname);
            }

        }
      }
      
      this.obj.reset();
    }
  };
</script>

<style>
#deneme{
  font-weight: bold;
  color:red;
  font-size: 14px; 
}
.filenames{
  font-weight: bold;
   font-size: 16px; 
}
.ort{
 
  font-size: 14px; 
  font-weight: bold;
  border-style: inset;
}
.ort2{
  margin-left:35%;
  margin-top:2%;
}
.etbil{
  font-weight: bold;
  font-size: 16px; 
}
</style>